import clsx from "clsx";
import { GatsbyLinkProps, Link } from "gatsby";
import { default as React, ReactNode, useEffect, useState } from "react";
import { Arrow } from "./Navbar";

export const LinkAsButton = ({
    to,
    ref,
    arrowDirection = "right",
    preserveSearch = true,
    ...props
}: {
    children: ReactNode;
    className?: string;
    noArrow?: boolean;
    preserveSearch?: boolean;
    arrowDirection?: "right" | "left";
    to: string;
} & GatsbyLinkProps<any>) => {
    const search = useGetCurrentSearch();
    return (
        <Link
            {...props}
            to={`${to}${preserveSearch ? search : ""}`}
            className={clsx(
                `font-medium w-fit group/arrow flex whitespace-nowrap 
                items-center rounded-full py-1.5 px-4 text-sm transition-transform `,
                props.className,
            )}
        >
            {!props.noArrow && arrowDirection === "left" && <Arrow flip />}
            {props.children}
            {!props.noArrow && arrowDirection === "right" && <Arrow />}
        </Link>
    );
};

export const useGetCurrentSearch = () => {
    const [search, setUrlParams] = useState(``);
    useEffect(() => {
        if (typeof window !== "undefined") {
            const queryString = window.location.search;
            if (queryString) setUrlParams(queryString);
        }
    }, []);
    return search;
};
